var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "site-header",
      class: { open: _vm.isOpen },
      attrs: { id: "site-header" }
    },
    [
      _c("div", { staticClass: "content-max-width" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c("a", { staticClass: "tel", attrs: { href: _vm.data.phone_url } }, [
            _vm._v(_vm._s(_vm.data.phone))
          ]),
          _vm._v(" "),
          _vm.facebook
            ? _c(
                "a",
                {
                  staticClass: "fb",
                  attrs: { href: _vm.facebook, target: "_blank" }
                },
                [
                  _c("img", {
                    attrs: { src: "/images/fb.png", alt: "ECB Vet Facebook" }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.data.header_btn_link
            ? _c(
                "a",
                {
                  staticClass: "button",
                  attrs: { href: _vm.data.header_btn_link, target: "_blank" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.data.header_btn_title) +
                      "\n      "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "hamburger mobile", on: { click: _vm.toggleMenu } },
            [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("nav", [
        _c(
          "ul",
          { staticClass: "top" },
          [
            _vm._l(_vm.nav, function(link, index) {
              return _c("li", { key: index }, [
                _c("a", { attrs: { href: link.url } }, [
                  _vm._v("\n          " + _vm._s(link.title) + "\n        ")
                ])
              ])
            }),
            _vm._v(" "),
            _c("li", { staticClass: "fb-menu" }, [
              _c("a", { attrs: { href: _vm.facebook, target: "_blank" } }, [
                _c("img", {
                  attrs: { src: "/images/fb.png", alt: "ECB Vet Facebook" }
                })
              ])
            ])
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo", attrs: { href: "/" } }, [
      _c("img", { attrs: { src: "/images/logo.jpg", alt: "ECB Vet logo" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }